"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("typeorm");
const typeorm_2 = require("@nestjs/typeorm");
const user_1 = require("../../../../service-lib/src/lib/entities/user");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
let UserRepository = class UserRepository {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }
    /**
     * Finds a user by login name or email and selects only emailId, mobile, and loginName.
     * @param loginName - The login name or email of the user.
     * @returns The user entity with selected fields or null if not found.
     */
    async findByLoginNameOrEmail(loginName) {
        try {
            const user = await this.userRepository.findOne({
                where: [{ emailId: loginName }, { loginName: loginName }],
                relations: ["userRoles", "userRoles.role"],
            });
            if (user) {
                // Ensure userRoles is defined and filter out undefined roles
                const roles = (user.userRoles || [])
                    .filter((userRole) => userRole?.role) // Filter out undefined roles
                    .map((userRole) => ({
                    id: userRole.role.id,
                    name: userRole.role.name,
                }));
                return {
                    userId: user.userId,
                    salutation: user.salutation,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    emailId: user.emailId,
                    mobile: user.mobile,
                    // loginName: user.loginName,
                    password: user.password,
                    roles,
                };
            }
            throw new common_1.NotFoundException(messages_1.errorMessages.userNotFound);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(messages_1.errorMessages.failedToFindUser);
        }
    }
    async findById(userId) {
        try {
            const user = await this.userRepository.findOne({
                where: { userId },
                relations: [
                    "userRoles",
                    "userRoles.role",
                    "salutation",
                    "organisation.country",
                ],
            });
            if (user) {
                // Ensure userRoles is defined and filter out undefined roles
                const roles = (user.userRoles || [])
                    .filter((userRole) => userRole?.role)
                    .map((userRole) => ({
                    id: userRole.role.id,
                    name: userRole.role.name,
                    description: userRole.role.description,
                }));
                const country = user.organisation?.country;
                let currency = null;
                if (country && country.id) {
                    currency = await this.userRepository.manager.findOne("Currency", {
                        where: { countryId: country.id },
                    });
                    if (currency) {
                        currency = {
                            id: currency?.id,
                            name: currency?.name,
                            value: currency?.value,
                            description: currency?.description,
                        };
                    }
                }
                return {
                    userId: user.userId,
                    salutation: user.salutation
                        ? {
                            id: user.salutation.id,
                            lookUpValue: user.salutation.lookUpValue,
                        }
                        : null,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    emailId: user.emailId,
                    mobile: user.mobile,
                    // loginName: user.loginName,
                    roles,
                    country,
                    currency,
                };
            }
            throw new common_1.NotFoundException(messages_1.errorMessages.userNotFound);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.BadRequestException(messages_1.errorMessages.failedToFindUser);
        }
    }
};
exports.UserRepository = UserRepository;
exports.UserRepository = UserRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_2.InjectRepository)(user_1.User)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_1.Repository !== "undefined" && typeorm_1.Repository) === "function" ? _a : Object])
], UserRepository);
